import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading } from '@/decorators';
import { namespace } from 'vuex-class';
var User = namespace('user');

var ProtocolLog = function (_super) {
  __extends(ProtocolLog, _super);

  function ProtocolLog() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.logoutLoading = false;
    return _this;
  }

  Object.defineProperty(ProtocolLog.prototype, "isInactive", {
    get: function get() {
      var _a;

      return ((_a = this.userInfo) === null || _a === void 0 ? void 0 : _a.customer_status) === this.$enum.mine.UserStatus.INACTIVE;
    },
    enumerable: false,
    configurable: true
  });

  ProtocolLog.prototype.handleLogout = function () {
    return __awaiter(this, void 0, Promise, function () {
      var code;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.user.logout()];

          case 1:
            code = _a.sent().code;

            if (!code) {
              this.$message.success(this.t('common', '退出成功'));
              this.clearUserData();
              window.location.href = this.$config.loginUrl;
            }

            return [2];
        }
      });
    });
  };

  ProtocolLog.prototype.handleSignOff = function () {
    this.$router.push({
      name: 'CustomerLogoutAccountPage'
    });
  };

  ProtocolLog.prototype.onIsInactiveChange = function () {
    if (!this.$util.isEmpty(this.userInfo.customer_status) && !this.isInactive) {
      this.$router.push({
        name: 'IndexPage'
      });
    }
  };

  ProtocolLog.prototype.created = function () {
    this.onIsInactiveChange();
  };

  __decorate([User.State('userInfo')], ProtocolLog.prototype, "userInfo", void 0);

  __decorate([User.Action('clearUserData')], ProtocolLog.prototype, "clearUserData", void 0);

  __decorate([loading('logoutLoading')], ProtocolLog.prototype, "handleLogout", null);

  __decorate([Watch('isInactive')], ProtocolLog.prototype, "onIsInactiveChange", null);

  ProtocolLog = __decorate([Component], ProtocolLog);
  return ProtocolLog;
}(Vue);

export default ProtocolLog;